import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { GlobalService } from 'src/app/global.service';
import { IcustomerService } from '../icustomer.service';
import { MatDialog } from '@angular/material/dialog';
import { BoothChangeForOrderComponent } from '../booth-change-for-order/booth-change-for-order.component';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';

@Component({
  selector: 'app-icustomer-booth-change',
  templateUrl: './icustomer-booth-change.component.html',
  styleUrls: ['./icustomer-booth-change.component.scss']
})
export class IcustomerBoothChangeComponent implements OnInit {
  product_form_dict: any = { 'total_price_per_order': 0 };
  product_list: any;
  session_list: any;
  final_price: any;
  total_days_in_next_month: number;
  today: any;
  monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  next_month_value_in_number: number;
  next_month_start_date_in_string: any;
  business_details: any;
  pincode: any;
  product_availability: any;
  icustomer_id: any = null;
  icustomer_verified = false;
  icustomer_detail: Object;
  milk_limit: any;
  total_quantity: any = 0;
  old_employee_product_list: any;
  icustomer_type_id: any;
  showerror: boolean = false;
  icustomer_code: any = null;
  icustomer_mobile: any = null;
  is_counter_selected: boolean = false;
  counter_list: any;
  collection_center: any = [];
  logged_user_befere_select_counter: any;
  sale_group_data: any;
  login_users: any;
  total_amount_in_counter: any;
  counter_name: any;
  today_date_time: any = new Date();
  future_order: any;
  month_and_year: any = null;
  selected_index: any = null;
  selected_date: string;
  total_days_in_month: number;
  product_form_dict_for_future_order: {};
  business_details_for_future: any;
  current_month_for_future_order_check = new Date().getMonth() + 1;
  current_year_for_future_order_check = new Date().getFullYear();
  disable_button = false;
  total_booth_count: any;
  is_deteted = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  time_range_for_limit = {};
  title: any;

  constructor(private httpService: HttpService, private global: GlobalService, private service: IcustomerService,
    public dialog: MatDialog) {
    this.title = this.global._active_display_name;
    setTimeout(() => document.getElementById('customer_code').focus(), 500);
    this.httpService.serveBoothChangeTimeRange().subscribe((data) => {
      console.log(data);
      this.time_range_for_limit = data;
    }, (error) => {
      console.error(error);
    });
    console.log(this.current_month_for_future_order_check);
    console.log(this.current_year_for_future_order_check);
  }

  changeButtonEnable(date) {
    let current_month_first_date = new Date(new Date(new Date().setDate(1)).toISOString().split('T')[0]);
    if (new Date(date) >= current_month_first_date) {
      return true;
    } else {
      return false;
    }
  }

  checkForBoothChangeButtonDisable() {
    let current_time = String(new Date().getHours()) + ':' + String(new Date().getMinutes()) + ':' + String(new Date().getSeconds());
    if (current_time >= this.time_range_for_limit['from_time'] && current_time <= this.time_range_for_limit['to_time']) {
      return false;
    } else {
      return true;
    }
  }

  getIcustomerDetails(data_from = null) {
    if (data_from !== null) {
      if (data_from === 'code') {
        if (this.icustomer_code == null || this.icustomer_code === '') {
          alert('Please enter a custmer code to Search for');
          return false;
        }
      } else {
        if (this.icustomer_mobile == null || this.icustomer_mobile === '') {
          alert('Please enter a phone number to Search for');
          return false;
        }
      }
    }
    let data_dict = { 'icustomer_number': this.icustomer_mobile, 'icustomer_code': this.icustomer_code };
    this.httpService.checkIcustomerDetails(data_dict).subscribe((data) => {
      console.log('customer details', data);
      if (data['found']) {
        this.icustomer_verified = true;
        this.icustomer_detail = data;
        this.icustomer_id = data['icustomer_id'];
        // this.service.set_icustomer_data = data['icustomer_id']
        this.final_price = null;
        this.total_days_in_next_month = null;
        this.milk_limit = null;
        this.total_quantity = 0;
        this.serveProductList();
      } else {
        if (this.icustomer_code !== null) {
          alert(String(this.icustomer_code) + ' is not a valid Customer code. Please Check');
          this.icustomer_code = null;
        } else {
          alert(String(this.icustomer_mobile) + ' is not a valid Phone number. Please Check');
          this.icustomer_mobile = null;
        }

      }
    }, (error) => {
      console.log(error);
    });
  }

  async serveProductList() {
    const data_dict = {
      'icustomer_id': this.icustomer_id,
      'from': 'portal'
    };
    this.httpService.serveProductListForICustomer(data_dict).subscribe((data) => {
      console.log(data);
      this.product_list = data['product_list'];
      this.session_list = data['session_list'];
      this.product_availability = data['product_availability'];
      this.milk_limit = data['milk_limit'];
      this.old_employee_product_list = data['old_employee_product_list'];
      console.log(this.old_employee_product_list);
      const service_dict = {
        'icustomer_type_id': data['icustomer_type_id'],
        'old_employee_products': this.old_employee_product_list
      };
      this.icustomer_type_id = data['icustomer_type_id'];
      this.getHistroy();
    }, (error) => {
      console.error(error);
    });
  }

  serveBusinessDetails() {
    const data_dict = {
      'icustomer_id': this.icustomer_id,
      'from': 'portal'
    };
    this.httpService.serveCustomerBusinessDetails(data_dict).subscribe((data) => {
      console.log(data);
      this.business_details = data;

    }, (error) => {
      console.error(error);
    });
  }

  getHistroy() {
    const data_dict = {
      'icustomer_id': this.icustomer_id,
      'from': 'portal',
      'data_for': 'future'
    };
    this.httpService.serveIcustomerHistory(data_dict).subscribe((data) => {
      console.log(data);
      this.future_order = data;
    }, (error) => {
      console.error(error);
    });
  }

  onPageTitleSelected(index) {
    if (this.selected_index === index) {
      this.selected_index = null;
    } else {
      this.selected_index = index;
    }
    // this.selected_heading_index = null;
  }

  eventEmitClickedOnCustmerCode(event, data_from) {
    let key_code = event.keyCode;
    if (key_code === 13) {
      this.getIcustomerDetails(data_from);
    } else if (key_code === 39) {
      document.getElementById('customer_phone_number').focus();
    }
  }



  eventEmitClickedOnCustmerPhone(event, data_from) {
    console.log(event);
    let key_code = event.keyCode;
    if (key_code === 13) {
      this.getIcustomerDetails(data_from);
    } else if (key_code === 37) {
      document.getElementById('customer_code').focus();
    }
  }

  routeToDetailPage(month_and_year, index) {
    this.onPageTitleSelected(index);
    this.selected_date = month_and_year['year'] + '-' + month_and_year['month'] + '-' + '01';
    this.serveCustomerFutureOrders();
    this.month_and_year = month_and_year;
  }

  async serveCustomerFutureOrders() {
    let data_dict = {
      'selected_date': this.selected_date,
      'from': 'portal',
      'icustomer_id': this.icustomer_id
    };
    this.httpService.serveSelectedMonthSaleForIcustomer(data_dict).subscribe((product_data) => {
      console.log(product_data);
      let date = new Date(this.selected_date);
      this.total_days_in_month = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
      this.product_form_dict_for_future_order = {};
      this.product_form_dict_for_future_order['product'] = {};
      this.product_form_dict_for_future_order['total_price_per_product_per_day'] = {};
      this.product_form_dict_for_future_order['total_price_per_product_per_month'] = {};
      this.product_form_dict_for_future_order['total_price_per_session'] = {};
      this.business_details_for_future = product_data['business_details']
      // this.product_form_dict_for_future_order['total_price_per_order'] = 0;
      this.session_list.forEach(session_element => {
        this.product_form_dict_for_future_order['product'][session_element.id] = {};
        if (product_data['product'].hasOwnProperty(session_element.id)) {
          this.product_list.forEach(product_element => {
            if (product_data['product'][session_element.id].hasOwnProperty(product_element.product_id)) {
              this.product_form_dict_for_future_order['product'][session_element.id][product_element.product_id] = product_data['product'][session_element.id][product_element.product_id]
            } else {
              this.product_form_dict_for_future_order['product'][session_element.id][product_element.product_id] = {
                'quantity': null,
                'price': 0
              };
            }
          });
        } else {
          // this.product_form_dict_for_future_order['total_price_per_session'][session_element.id] = 0;
          this.product_list.forEach(product_element => {
            this.product_form_dict_for_future_order['product'][session_element.id][product_element.product_id] = {
              'quantity': null,
              'price': 0
            };
          });
        }
        this.product_list.forEach(product_element => {
          if (product_data['total_price_per_product'].hasOwnProperty(product_element.product_id)) {
            this.product_form_dict_for_future_order['total_price_per_product_per_month'][product_element.product_id] = product_data['total_price_per_product'][product_element.product_id] * this.total_days_in_month;
          } else {
            this.product_form_dict_for_future_order['total_price_per_product_per_month'][product_element.product_id] = 0;
          }
        });
      });
      this.product_form_dict_for_future_order['total_price_per_order'] = 0;
      this.product_list.forEach(product_element => {
        this.product_form_dict_for_future_order['total_price_per_order'] += this.product_form_dict_for_future_order['total_price_per_product_per_month'][product_element.product_id];
      });
      console.log(this.product_form_dict_for_future_order);
    }, (error) => {
      console.error(error);
    });
  }

  async boothChangeClicked(page_action) {
    console.log('dialog open');
    const dialogRef = this.dialog.open(BoothChangeForOrderComponent, {
      height: '600px',
      width: '800px',
      data: {
        'pincode': this.icustomer_detail['pincode'],
        'user_profile_id': this.icustomer_detail['user_profile_id'],
        'page_action': page_action,
        'selected_date': this.month_and_year
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      const res = result;
      if (res) {
        if (page_action === 'register') {
          this.serveBusinessDetails();
        } else {
          this.serveCustomerFutureOrders();
        }
      }
    });
  }

  ngOnInit() {
  }

}
